// FETCH ALL DYEING INWARD DETAILS
export const FETCH_DYEING_INWARD_DETAILS_REQUEST = 'FETCH_DYEING_INWARD_DETAILS_REQUEST';
export const FETCH_DYEING_INWARD_DETAILS_SUCCESS = 'FETCH_DYEING_INWARD_DETAILS_SUCCESS';
export const FETCH_DYEING_INWARD_DETAILS_FAILURE = 'FETCH_DYEING_INWARD_DETAILS_FAILURE';

// FETCH ALL DYEING INWARD DETAILS
export const FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_FAILURE';

// CREATE DYEING INWARD DETAILS
export const CREATE_DYEING_INWARD_DETAILS_REQUEST = 'CREATE_DYEING_INWARD_DETAILS_REQUEST';
export const CREATE_DYEING_INWARD_DETAILS_SUCCESS = 'CREATE_DYEING_INWARD_DETAILS_SUCCESS';
export const CREATE_DYEING_INWARD_DETAILS_FAILURE = 'CREATE_DYEING_INWARD_DETAILS_FAILURE';

// UPDATE DYEING INWARD DETAILS
export const UPDATE_DYEING_INWARD_DETAILS_REQUEST = 'UPDATE_DYEING_INWARD_DETAILS_REQUEST';
export const UPDATE_DYEING_INWARD_DETAILS_SUCCESS = 'UPDATE_DYEING_INWARD_DETAILS_SUCCESS';
export const UPDATE_DYEING_INWARD_DETAILS_FAILURE = 'UPDATE_DYEING_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF DYEING INWARD DETAILS
export const FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM DYEING_INWARD DETAILS
export const FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE';

// DELETE DYEING INWARD DETAILS
export const DELETE_DYEING_INWARD_DETAILS_REQUEST = 'DELETE_DYEING_INWARD_DETAILS_REQUEST';
export const DELETE_DYEING_INWARD_DETAILS_SUCCESS = 'DELETE_DYEING_INWARD_DETAILS_SUCCESS';
export const DELETE_DYEING_INWARD_DETAILS_FAILURE = 'DELETE_DYEING_INWARD_DETAILS_FAILURE';

export const FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_REQUEST = 'FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_REQUEST';
export const FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_SUCCESS = 'FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_SUCCESS';
export const FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_FAILURE = 'FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_FAILURE';

export const RESET_DYEING_INWARD_DETAILS_INFO = 'RESET_DYEING_INWARD_DETAILS_INFO';
export const DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED = 'DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED';

export const CREATE_DYEING_INWARD_DETAILS_FORM = 'CREATE_DYEING_INWARD_DETAILS_FORM';

export const UPDATE_DYEING_INWARD_DETAILS_FORM = 'UPDATE_DYEING_INWARD_DETAILS_FORM';
